import { useApiMutation } from '@locus-taxy/encore-ui-network';
import { useToast } from '@locus-taxy/encore-ui-toolkit';
import type { ApiError } from '@locus-taxy/encore-ui-network';

export function useEntityInstanceWorkflowAction(
  clientId: string,
  entityName: string,
  instanceId: string | null
) {
  const { showApiError } = useToast();

  return useApiMutation<
    EntityInstanceWorkflowActionResponse,
    EntityInstanceWorkflowActionRequest
  >({
    endpointKey: 'workflow.action',
    params: { clientId, entityName, instanceId: instanceId || '' },
    config: {
      onError: (error: ApiError) => {
        showApiError(error);
      },
    },
  });
}

// Add types for the workflow action
export interface EntityInstanceWorkflowActionRequest {
  actionId: string;
  actionReference?: string;
  variables: Record<string, unknown>;
}

export interface EntityInstanceWorkflowActionResponse {
  success: boolean;
  [key: string]: unknown;
}

export default useEntityInstanceWorkflowAction;
